import request from '@/utils/request'

export const cacQuizsGet = (options = {}) => request({
    url: '/quiz_apis/cac_quizs',
    method: 'get',
    ...options
})

export const cacQuizResultsPost = (options = {}) => request({
    url: '/quiz_apis/cac_quiz_results',
    method: 'post',
    ...options
})

export const cacQuizResultResultIdGet = (options = {}) => request({
    url: '/quiz_apis/cac_quiz_result/{resultId}',
    method: 'get',
    ...options
})
